import * as React from "react"
import Svg, { Path } from "react-native-svg"

const ArrowBackIcon = (props) => (
    <Svg
        width={27}
        height={23}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M.163 11a1 1 0 0 1 1-1h24a1 1 0 0 1 0 2h-24a1 1 0 0 1-1-1Z"
            fill="#242424"
        />
        <Path
            d="M.297 11.894a1.016 1.016 0 0 1 0-1.436L10.423.332a1.016 1.016 0 0 1 1.437 1.436L1.734 11.894a1.016 1.016 0 0 1-1.437 0Z"
            fill="#242424"
        />
        <Path
            d="M.311 10.512a1 1 0 0 0 0 1.414l10.145 10.145a1 1 0 0 0 1.415-1.414L1.726 10.512a1 1 0 0 0-1.415 0Z"
            fill="#242424"
        />
    </Svg>
)

export default ArrowBackIcon
